export enum DateType {
    FIXED_DATE = 'FIXED_DATE',
    INTERVAL_DATE = 'INTERVAL_DATE'
}

export class IntervalDate {
  public id?: string;
  public start?: Date;
  public end?: Date;
  public type = DateType.INTERVAL_DATE as const;
}

export class FixedDate {
  public id?: string;
  public date?: Date;
  public type = DateType.FIXED_DATE as const;
}
